module.exports = __webpack_public_path__ + "static/media/train3.8f6a3868.png";